/** @format */

import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Deji from "../assets/images/Media.png";

const Recommendations = () => {
	return (
		<>
			<div className="row hidden">
			<h4 className='font-weight-bold'>Recommendations</h4>
				<div className="col-lg-9 offset-lg">	
					<Carousel>
						<div className="row bg-light">
							<div className="col-4">
								<img src={Deji} className="image-fluid" alt="" />
							</div>
							<div className="col-8 carousel-text">
								<h3>
									“Working with Adio Mojeed, was a great
									experience. I would love to work with him in
									the future.”
								</h3>
								<div>
									<p>Adedeji Stephen</p>
									<p className="handle__recommend">
										@ionware
									</p>
									<p>
										<a href="https://github.com/Adiomojeed">
											<i className="fab fa-linkedin"></i>
										</a>
										<a href="https://github.com/Adiomojeed">
											<i className="fab fa-github"></i>
										</a>
										<a href="https://github.com/Adiomojeed">
											<i className="fab fa-twitter"></i>
										</a>
									</p>
								</div>
							</div>
						</div>
					</Carousel>
				</div>
			</div>
		</>
	);
};

export default Recommendations;
